import { Directive, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[sm-pale]' })
export class SalonMonsterPaleDirective {
    constructor(el: ElementRef) {
       el.nativeElement.style.color = '#777';
    }
}